import React, { createContext, useContext, useEffect, useState } from 'react';

const OnboardingContext = createContext();

const CACHE_KEY = 'cyclegala_onboarding_cache';
const SENSITIVE_FIELDS = ['email', 'password', 'confirmPassword'];

const defaultFormData = {
  email: '',
  password: '',
  confirmPassword: '',
  firstName: '',
  lastName: '',
  birthDate: '',
  height: '',
  weight: '',
  sport: [],
  level: '',
  contraception: '',
  // Dates de cycle déclarées à l'inscription (facultatives, format ISO).
  // Elles amorcent les prédictions au lieu de laisser la page Cycle vide.
  lastPeriodDate: '',
  lastOvulationDate: '',
  consentAccepted: false,
};

// Ne cache jamais email/mot de passe : seul le reste du profil est restauré
// pour simplifier une nouvelle tentative d'inscription si la validation du
// code de vérification échoue.
const loadCachedFormData = () => {
  try {
    const cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || '{}');
    return { ...defaultFormData, ...cached };
  } catch {
    return { ...defaultFormData };
  }
};

export const useOnboarding = () => {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error('useOnboarding must be used within an OnboardingProvider');
  }
  return context;
};

export const OnboardingProvider = ({ children }) => {
  const [formData, setFormData] = useState(loadCachedFormData);

  useEffect(() => {
    const toCache = { ...formData };
    SENSITIVE_FIELDS.forEach((field) => delete toCache[field]);
    sessionStorage.setItem(CACHE_KEY, JSON.stringify(toCache));
  }, [formData]);

  const updateField = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const resetForm = () => {
    sessionStorage.removeItem(CACHE_KEY);
    setFormData({
      ...defaultFormData,
      height: '165',
      weight: '60',
    });
  };

  return (
    <OnboardingContext.Provider value={{ formData, updateField, resetForm }}>
      {children}
    </OnboardingContext.Provider>
  );
};

export default OnboardingContext;
